namespace Solovis.Reports.Parameters.Stats {

    export class CustomTxGroupControl extends Solovis.UI.BaseControl {
        private _customTxGroup: StatSetOptionsCustomTxGroup;
        private _formBuilder: Solovis.UI.InputControls.FormBuilder;

        private _txTypeTagSet: InvData.Models.TagSet;

        constructor(options) {
            super(options);

            this._customTxGroup = options.customTxGroup;
        }

        public async doInitAsync() {
            // TODO: Add javascript constants for system tag set ids.
            let txTypeTagSetId = 102;
            this._txTypeTagSet = await Solovis.Reports.LocalCache.ModelEnvironmentCachedData.tryGetTagSetByIdAsync(txTypeTagSetId);
        }

        public doRender() {

            let formBuilderDiv = $("<div>").appendTo(this.container);
            let formBuilder = new Solovis.UI.InputControls.FormBuilder({
                container: formBuilderDiv,
                labelColumnWidth: 150,
                width: 350
            });
            this._formBuilder = formBuilder;

            formBuilder.addEntry({
                name: "label",
                label: "Group Label",

                initialValue: this._customTxGroup ? this._customTxGroup.label : null,

                editor: {
                    type: "text"
                }
            });

            let customEnvironmentUserData = formBuilder.portalServices().customEnvironmentUserData();

            // Determine perf variations
            let perfVariationsOptionsList = [];
            if (customEnvironmentUserData && customEnvironmentUserData.ModelSettings) {
                let modelSettings = customEnvironmentUserData.ModelSettings;
                if (modelSettings && modelSettings.performanceVariationsConfig && modelSettings.performanceVariationsConfig.variations) {
                    for (let variation of modelSettings.performanceVariationsConfig.variations) {
                        perfVariationsOptionsList.push({ text: variation.label, value: variation.code });
                    }
                }
            }

            formBuilder.addEntry({
                name: "code",
                label: "Group Code",

                initialValue: this._customTxGroup ? this._customTxGroup.code : null,

                editor: {
                    type: "text",

                    required: true,

                    isValid: (value, formEntry, validationModel) => {
                        if (value) {
                            for (let i = 0; i < value.length; i++) {
                                let ch = value.charAt(i);
                                ch = ch.toLowerCase();
                                if (i == 0) {
                                    if (!(ch >= "a" && ch <= "z")) {
                                        validationModel.setErrorMessage("Must start with letter and be followed by only letters and digits.");
                                        return false;
                                    }
                                }
                                else {
                                    if (!((ch >= "a" && ch <= "z") || (ch >= "0" && ch <= "9"))) {
                                        validationModel.setErrorMessage("Must start with letter and be followed by only letters and digits.");
                                        return false;
                                    }
                                }
                            }

                            return true;
                        }

                        return false;
                    }
                }
            });

            formBuilder.addEntry({
                name: "txFilterMethod",
                label: "Tx Filter Method",

                help: "Filter by either Tx Type Filters or Performance Variation.",

                initialValue: this._customTxGroup.performanceVariationCode ? "performanceVariationCode" : "txTypeFilter",

                editor: {
                    type: "select",
                    selectOptions: {
                        data: [
                            { text: "Tx Type Filter", value: "txTypeFilter" },
                            { text: "Performance Variation", value: "performanceVariationCode" },
                        ]
                    }
                },

                isVisible: () => { return !_.isEmpty(perfVariationsOptionsList); }
            });

            formBuilder.addEntry({
                name: "startOfDay",
                label: "Start Of Day",

                initialValue: this._customTxGroup ? !!this._customTxGroup.startOfDay : false,

                editor: {
                    type: "bool"
                },

                isVisible: () => this._formBuilder.getValueByName("txFilterMethod") == "txTypeFilter",
            });

            formBuilder.addEntry({
                name: "endOfDay",
                label: "End Of Day",

                initialValue: this._customTxGroup ? !!this._customTxGroup.endOfDay : false,

                editor: {
                    type: "bool"
                },

                isVisible: () => this._formBuilder.getValueByName("txFilterMethod") == "txTypeFilter",
            });

            formBuilder.addEntry({
                name: "forceStartOfDay",
                label: "Force Start Of Day",

                initialValue: this._customTxGroup ? !!this._customTxGroup.forceStartOfDay : false,

                editor: {
                    type: "bool"
                },

                isVisible: () => this._formBuilder.getValueByName("txFilterMethod") == "txTypeFilter",
            });

            formBuilder.addEntry({
                name: "forceEndOfDay",
                label: "Force End Of Day",

                initialValue: this._customTxGroup ? !!this._customTxGroup.forceEndOfDay : false,

                editor: {
                    type: "bool"
                },

                isVisible: () => this._formBuilder.getValueByName("txFilterMethod") == "txTypeFilter",
            });

            formBuilder.addEntry({
                name: "txTypeFilter",
                label: "Tx Type Filter",

                initialValue: (this._customTxGroup && this._customTxGroup.txTypeFilter) ? this._customTxGroup.txTypeFilter : null,

                createEditor: (createEditorOptions) => {
                    let tagFilterControl = new Solovis.Reports.TableFilters.TagFilterControl({
                        controlHost: createEditorOptions.container,
                        tagSet: this._txTypeTagSet,
                        initialState: createEditorOptions.initialValue
                    });
                    tagFilterControl.setAsCurrentControl();

                    let editor = {
                        getValue: () => {
                            return tagFilterControl.getCurrentState();
                        }
                    };

                    return editor;
                },

                isVisible: () => this._formBuilder.getValueByName("txFilterMethod") == "txTypeFilter",
            });

            formBuilder.addEntry({
                name: "performanceVariationCode",
                label: "Performance Variation",

                initialValue: this._customTxGroup.performanceVariationCode ? this._customTxGroup.performanceVariationCode : null,

                editor: {
                    type: "select",
                    selectOptions: {
                        data: perfVariationsOptionsList,
                        showClearButton: true
                    }
                },

                isVisible: () => this._formBuilder.getValueByName("txFilterMethod") == "performanceVariationCode",
            });
            
            formBuilder.setupDone();
        }


        public setWidth(newWidth) {
            if (this._formBuilder) {
                this._formBuilder.setWidth(newWidth);
            }
        }

        public isValid() {
            return !this._formBuilder.hasErrors();
        }

        public getCustomTxGroup() {            
            let customTxGroup: StatSetOptionsCustomTxGroup  = {};

            customTxGroup.label = this._formBuilder.getValueByName("label");
            customTxGroup.code = this._formBuilder.getValueByName("code");

            if (this._formBuilder.getValueByName("txFilterMethod") == "txTypeFilter") {
                customTxGroup.txTypeFilter = this._formBuilder.getValueByName("txTypeFilter");
                customTxGroup.performanceVariationCode = null;

                if (this._formBuilder.getValueByName("startOfDay")) {
                    customTxGroup.startOfDay = true;
                }

                if (this._formBuilder.getValueByName("endOfDay")) {
                    customTxGroup.endOfDay = true;
                }

                if (this._formBuilder.getValueByName("forceStartOfDay")) {
                    customTxGroup.forceStartOfDay = true;
                }

                if (this._formBuilder.getValueByName("forceEndOfDay")) {
                    customTxGroup.forceEndOfDay = true;
                }
            }
            else {
                customTxGroup.txTypeFilter = null;
                customTxGroup.performanceVariationCode = this._formBuilder.getValueByName("performanceVariationCode");
                customTxGroup.startOfDay = false;
                customTxGroup.endOfDay = false;
                customTxGroup.forceStartOfDay = false;
                customTxGroup.forceEndOfDay = false;
            }

            return customTxGroup;
        }


        public static showEditDialog(customTxGroup, saveCallback) {            
            let self = this;

            let editorDiv = $("<div>");

            let customTxGroupControl = new CustomTxGroupControl({
                controlHost: editorDiv,
                customTxGroup: customTxGroup
            });
            customTxGroupControl.setAsCurrentControl();

            let desiredWidth = Math.min($(window).width() * 0.9, 650);
            let desiredHeight = Math.min($(window).height() * 0.9, 750);

            let dialog = new Solovis.UI.Dialog({
                container: editorDiv,

                title: "Edit Custom Transaction Group",
                width: desiredWidth,
                height: desiredHeight,
                modal: true,
                center: true,
                autoOpen: true,
                actions: ["Close"],
                destroyOnClose: true,

                buttons: [
                    {
                        label: "OK",
                        click: function () {
                            if (customTxGroupControl.isValid()) {
                                saveCallback(customTxGroupControl.getCustomTxGroup());
                                dialog.close();
                            }
                        }
                    },
                    {
                        label: "Cancel",
                        click: function () {
                            dialog.close();
                        }
                    }
                ],

                contentWidthSizer: {
                    setWidth: function (newWidth) {
                        customTxGroupControl.setWidth(newWidth);
                    }
                }
            });        
        }
    }
}